module.exports = __webpack_public_path__ + "img/20231225110109259jfm.50b159a9.jpg";